<template>
	<div class="dialog-wrap">
		<div class="dialog-detail">
			<img src="../assets/img/close.png" class="close" @click="close" v-if="isShowClose">
			<slot></slot>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			isShowClose: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {

			}
		},

		methods: {
			close() {
				this.$emit('close')
			}
		}
	};
</script>

<style lang="scss" scoped>
	::-webkit-scrollbar {
		display: none;
	}

	.dialog-wrap {
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		z-index: 9;
		top: 0;
		left: 0;
		bottom: 0;
		width: 100%;
		height: 100%;
		background: rgba(0, 0, 0, 0.5);

		.dialog-detail {
			position: relative;
			width: 600px;
			box-sizing: border-box;
			background: #FFFFFF;
			box-shadow: 0px 13px 7px 0px rgba(0, 0, 0, 0.06);

			.close {
				position: absolute;
				right: 20px;
				top: 20px;
				width: 11px;
				height: 11px;
				cursor: pointer;
			}
		}
	}
</style>
